import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { openNativeModal } from 'components/Modal';
import { IRAContributionWays } from 'modules/Deposit/type';
import security from 'stores/security';
import icon from './images/icon-switch.svg';
import style from './style.scss';
import WayList from './WayList';

interface SwitchContributionWayProps {
    /**
     * 当前的入金方式
     */
    currentWay: IRAContributionWays;
}

const SwitchContributionWay: FC<SwitchContributionWayProps> = ({ currentWay }) => {
    const isIRA = security.isIRAAccount;
    const navigate = useNavigate();

    const navigateTo = (to: string) => {
        navigate(to, { replace: true });
    };

    const handleOpenModal = () => {
        openNativeModal({
            maskClosable: true,
            closable: true,
            title: __('Payment Method'),
            component: props => <WayList {...props} currentWay={currentWay} onItemClick={navigateTo} />
        }).result.catch(() => {});
    };

    if (!isIRA) {
        return null;
    }

    return (
        <button className={style.btn} onClick={handleOpenModal}>
            <img src={icon} alt="icon" />
            <span>{__('Switch')}</span>
        </button>
    );
};

export default SwitchContributionWay;
